import { MarketingArticle } from '../components/marketing/MarketingArticle';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { SignUpButton, TalkToFoundersButton } from '../components/CTAButtons';
import { SOLUTIONS_BREADCRUMB } from '../content/forFilmmakersPage';
import type { MarketingPageContent, RelatedLink } from '../content/pages/types';
import { PageSeo } from '../components/seo/PageSeo';
import { buildMarketingPageSchema } from '../lib/schema';
import type { PageMeta } from '../lib/seo';

type MarketingContentPageProps = {
  meta: PageMeta;
  content: MarketingPageContent;
  relatedLinks?: RelatedLink[];
  jsonLd?: Record<string, unknown>;
};

export function MarketingContentPage({ meta, content, relatedLinks, jsonLd }: MarketingContentPageProps) {
  return (
    <>
      <PageSeo meta={meta} />
      <JsonLd
        data={
          jsonLd ??
          buildMarketingPageSchema(content.title, meta.path, meta.description, {
            breadcrumbs: [...SOLUTIONS_BREADCRUMB, { label: content.headerLabel }],
          })
        }
      />
      <MarketingLandingShell>
        <MarketingArticle
          title={content.title}
          lede={content.lede}
          sections={[...content.sections]}
          relatedLinks={relatedLinks}
        >
          <SignUpButton variant="primary" />
          <TalkToFoundersButton variant="ghost" />
        </MarketingArticle>
      </MarketingLandingShell>
    </>
  );
}
